import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "../../util/dateUtils";

const NotificationCard = ({ data, handleClear }) => {
  const {
    notification_id,
    project_name,
    task_name,
    activity_log_notification,
  } = data;

  return (
    <div className="notification-card-container">
      <div className="top-header-wrapper">
        <div className="left-column-wrapper">
          <div className="arrow-wrapper">
            <div className="project">{project_name}</div>

            <FontAwesomeIcon icon={faChevronRight} className="chevron" />

            <div className="task">{task_name}</div>
            <span className="end-arrow" />
          </div>
        </div>

        <div className="right-column-wrapper">
          {handleClear ? (
            <Link to={`/task/${activity_log_notification.task_id}`}>
              <button
                onClick={() => {
                  handleClear(notification_id);
                }}
              >
                Open Task
              </button>
            </Link>
          ) : (
            <Link to={`/task/${activity_log_notification.task_id}`}>
              <button>Open Task</button>
            </Link>
          )}
        </div>
      </div>

      <div className="notification-details-wrapper">
        <div className="details">{activity_log_notification.details}</div>

        <div className="date">
          {formatDate(activity_log_notification.created_at, false, true)}
        </div>
      </div>
    </div>
  );
};

export default NotificationCard;
